"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    subtitle1ClassNames: function() {
        return subtitle1ClassNames;
    },
    useSubtitle1Styles: function() {
        return useSubtitle1Styles;
    }
});
const _react = require("@griffel/react");
const subtitle1ClassNames = {
    root: 'fui-Subtitle1'
};
const useSubtitle1Styles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "f1pp30po",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f106mvju"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f1pp30po{font-size:var(--fontSizeBase500);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".f106mvju{line-height:var(--lineHeightBase500);}"
    ]
}); //# sourceMappingURL=useSubtitle1Styles.styles.js.map
